import React, { useRef } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@mui/material';
import ControlPointRoundedIcon from '@mui/icons-material/ControlPointRounded';

const LoadButton = function LoadButton({
  onLoad = () => {},
  multiple = false,
  disabled = false,
  accept,
}) {
  const intl = useIntl();
  const fileInput = useRef();

  return (
    <>
      <Button
        id="upload-button"
        size="large"
        disabled={disabled}
        startIcon={<ControlPointRoundedIcon />}
        sx={{
          textTransform: 'none',
          width: '160px',
          height: '56px',
          fontSize: '18px',
        }}
        onClick={() => fileInput.current.click()}
      >
        {intl.messages.LOAD}
      </Button>
      <input
        id="file-upload-input"
        ref={fileInput}
        onChange={onLoad}
        type="file"
        accept={accept}
        multiple={multiple}
        hidden
      />
    </>
  );
};

export default LoadButton;
